var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiIcon',{staticClass:"ClearButton ToolbarButton",attrs:{"title":_vm.$t('ClearButton.title'),"value":"mdi:format-clear"},on:{"click":function($event){_vm.editor.chain().focus().clearNodes().unsetAllMarks().run()}}})}
var staticRenderFns = []

export { render, staticRenderFns }